import {Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class EstrategiaClienteService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Basket por id
     * @param id ID da Basket
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Basket
     * @param id ID da Basket
     */
    getEstrategiaMovimentacao(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/cliente-movimentacao"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Basket
     * @param id ID da Basket
     */
     getEstrategiaPosicao(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/cliente-posicao"+env, { headers: this.authService.getAuthHeaders() });
    }

    

}
